<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-8">
        <a (click)="location.back()" class="link-secondary font-default cursor-pointer">
          <svg class="icon icon-21"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
          {{ 'instrument-detail.asset-timeline.back' | transloco }}
        </a>
        <div class="tile mt-4 title">
          <div class="d-flex align-items-center title-container">
            @if (asset) {
              @if (asset.iconUrl) {
                <img [src]="asset?.iconUrl" alt="logo" class="logo mr-2" />
              }
              <h2 class="font-bold" [title]="asset.name">
                <span>{{ asset.name.length > 45 ? (asset.name | slice: 0 : 45) + '...' : asset.name }}</span>
              </h2>
            }
          </div>
          <div class="section-container">
            @if ((facade.assetTimelineLoading$ | async) && (facade.assetTimelineInitiallyLoaded$ | async) === false) {
              <div class="section mt-3">
                <span class="text-color-grey font-medium text-size-small">{{
                  'instrument-detail.asset-timeline.loading' | transloco
                }}</span>
              </div>
            } @else if (facade.assetTimelineError$ | async) {
              <p class="text-color-error mt-3">{{ facade.assetTimelineError$ | async }}</p>
            } @else {
              @if (facade.assetTimeline$ | async; as assetTimeline) {
                <div class="section mt-3">
                  <span class="hint text-color-grey font-medium text-size-small">{{
                    'instrument-detail.asset-timeline.invested' | transloco
                  }}</span>
                  <span [class]="'font-bold dynamic-text-size length-' + (assetTimeline.sumInvested | number: '1.2-2').length"
                    >{{ assetTimeline.sumInvested | number: '1.2-2' }}&nbsp;€</span
                  >
                </div>
                <div class="spacer mt-3"></div>
                <div class="section mt-3">
                  <span class="text-color-grey font-medium text-size-small">{{
                    'instrument-detail.asset-timeline.deinvested' | transloco
                  }}</span>
                  <span [class]="'font-bold dynamic-text-size length-' + (assetTimeline.sumDeinvested | number: '1.2-2').length"
                    >{{ assetTimeline.sumDeinvested | number: '1.2-2' }}&nbsp;€</span
                  >
                </div>
                <div class="spacer mt-3"></div>
                <div class="section mt-3">
                  <span class="text-color-grey font-medium text-size-small">{{ 'instrument-detail.asset-timeline.hold' | transloco }}</span>
                  <span [class]="'font-bold dynamic-text-size length-' + (assetTimeline.currentPositionValue | number: '1.2-2').length"
                    >{{ assetTimeline.currentPositionValue | number: '1.2-2' }}&nbsp;€</span
                  >
                </div>
                <div class="spacer mt-3"></div>
                <div class="section mt-3">
                  <span
                    class="text-color-grey font-medium text-size-small"
                    [innerHTML]="'instrument-detail.asset-timeline.other' | transloco"
                  ></span>
                  <span [class]="'font-bold dynamic-text-size length-' + (assetTimeline.sumOther | number: '1.2-2').length"
                    >{{ assetTimeline.sumOther | number: '1.2-2' }}&nbsp;€</span
                  >
                </div>
                <div class="spacer mt-3"></div>
                <div class="section mt-3">
                  <span class="text-color-grey font-medium text-size-small">{{ 'instrument-detail.asset-timeline.sum' | transloco }}</span>
                  <span
                    [class]="'font-bold dynamic-text-size length-' + (assetTimeline.saldo | number: '1.2-2').length"
                    [class.text-color-success]="assetTimeline.saldo > 0"
                    [class.text-color-error]="assetTimeline.saldo < 0"
                  >
                    {{ (assetTimeline.saldo > 0 ? '+' : '') + (assetTimeline.saldo | number: '1.2-2') }}&nbsp;€
                  </span>
                </div>
              }
            }
          </div>
        </div>
        <div class="tile asset-timeline">
          <h2 class="font-medium">{{ 'instrument-detail.asset-timeline.title' | transloco }}</h2>
          <div
            class="text-color-grey font-regular text-size-xsmall mt-1 mb-2"
            [innerHTML]="'instrument-detail.asset-timeline.text' | transloco"
          ></div>
          <div class="section-container">
            <div class="section">
              <span class="font-bold text-size-small" [innerHTML]="'instrument-detail.asset-timeline.quantity-date' | transloco"></span>
            </div>
            <div class="section">
              <span class="font-bold text-size-small" [innerHTML]="'instrument-detail.asset-timeline.price-type' | transloco"> </span>
            </div>
            <div class="section">
              <span class="font-bold text-size-small" [innerHTML]="'instrument-detail.asset-timeline.cost-status' | transloco"></span>
            </div>
          </div>

          @if (facade.assetTimelineItems$ | async; as assetTimelineItems) {
            @for (assetTimelineItem of assetTimelineItems; track $index) {
              <instrument-details-instrument-asset-timeline-item [item]="assetTimelineItem" />
            }
          }

          @if (facade.assetTimelineLoading$ | async) {
            <div class="section-container">
              @for (_ of [1, 2, 3]; track $index) {
                <div class="section">
                  <div class="loading-shimmer"></div>
                </div>
              }
            </div>
          }

          @if ((facade.assetTimelineInitiallyLoaded$ | async) && (facade.assetTimelineItems$ | async)) {
            <div class="mt-2 d-flex justify-content-end">
              <a
                class="cursor-pointer link-secondary"
                (click)="nextPage()"
                [class.hidden]="(facade.assetTimelineHasNext$ | async) === false || (facade.assetTimelineLoading$ | async)"
              >
                {{ 'instrument-detail.asset-timeline.more' | transloco }} <span class="sorter-after-flat sorter-after-flat--down"></span>
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
